import React from 'react';
import { PropTypes } from 'prop-types';

import { PageHeader, Tab, Tabs, Grid, Row, Col } from '@sm/wds-react';
import { defineMessages, t } from '@sm/intl';

import './user-account-base-page.scss';

const COPY = defineMessages({
  PAGE_HEADER: {
    id: 'User.UserAccountBasePage.HeaderTitle',
    defaultMessage: 'My Account',
    description: '[Type: Header][Vis.: high] - User account page header',
  },
  ACCOUNT_SUMMARY: {
    id: 'User.UserAccountBasePage.AccountSummaryTab',
    defaultMessage: 'ACCOUNT SUMMARY',
    description: '[Type: Button][Vis.: med] - Account summary page subheader tab',
  },
  BILLING_DETAILS: {
    id: 'User.UserAccountBasePage.BillingDetailsTab',
    defaultMessage: 'BILLING DETAILS',
    description: '[Type: Button][Vis.: med] - Billing details page subheader tab',
  },
  TRANSACTION_HISTORY: {
    id: 'User.UserAccountBasePage.TransactionHistoryTab',
    defaultMessage: 'TRANSACTION HISTORY',
    description: '[Type: Button][Vis.: med] - Transaction history page subheader tab',
  },
});

const USER_ACCOUNT_TABS = [
  {
    page: 'myAccount',
    title: COPY.ACCOUNT_SUMMARY,
    path: '/account',
  },
  {
    page: 'billingDetails',
    title: COPY.BILLING_DETAILS,
    path: '/billing',
  },
  {
    page: 'transactionHistory',
    title: COPY.TRANSACTION_HISTORY,
    path: '/billing/history',
  },
];

const UserAccountBasePage = ({ activePage, children, sideBar }) => (
  <div className="sm-user-account-base-page" data-testid="UserAccountBasePage">
    <div className="sm-user-account-base-page__page-header">
      <PageHeader title={t(COPY.PAGE_HEADER)} />
    </div>
    <div className="sm-user-account-base-page__navigation-tabs">
      <Tabs
        onChange={(e, path) => {
          window.location.assign(path);
        }}
      >
        {USER_ACCOUNT_TABS.map(({ page, title, path }) => (
          <Tab title={t(title)} selected={page === activePage} id={path} key={page} />
        ))}
      </Tabs>
    </div>
    <div className="sm-user-account-base-page__content wds-p-t-6 wds-p-b-6">
      <Grid noBleeds>
        <Row>
          <Col xs={9}>{children}</Col>
          <Col xs={3}>{sideBar}</Col>
        </Row>
      </Grid>
    </div>
  </div>
);

UserAccountBasePage.propTypes = {
  activePage: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  sideBar: PropTypes.node,
};

UserAccountBasePage.defaultProps = {
  sideBar: null,
};

export default UserAccountBasePage;
